import managerYearInlineComponent from './managerYearInline.component';
import managerYearInlineService from './managerYearInline.service';
import managerYearInlineFilter from './managerYearInline.filters';

let managerYearInlineModule = angular.module('vacations-absences.managerYearInline', [])

.component('managerYearInline', managerYearInlineComponent)

.service('managerYearInlineService', managerYearInlineService)

.filter('managerYearInlineFilter',managerYearInlineFilter)

.name;

export default managerYearInlineModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.js